import React from "react";

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

const IconNewsletter = ({
  width = 18,
  height = 18,
  color = "black",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12.0964 3.50439C12.3794 3.52422 12.6541 3.61307 12.8962 3.76318C13.1725 3.93449 13.3959 4.17928 13.5408 4.47021L15.53 8.44385C15.7341 8.54673 15.8748 8.75638 15.8748 9.00049C15.8747 9.14011 15.8272 9.26757 15.7498 9.37158V12.7505C15.7497 13.2145 15.5652 13.6597 15.2371 13.9878C14.9089 14.3158 14.4637 14.5005 13.9998 14.5005H3.99976C3.53575 14.5004 3.09056 14.3159 2.76245 13.9878C2.43434 13.6597 2.24984 13.2145 2.24976 12.7505V9.36963C2.17303 9.26589 2.12483 9.13941 2.12476 9.00049C2.12476 8.75705 2.26538 8.54802 2.46851 8.44482L4.45874 4.47021C4.60357 4.17941 4.82721 3.93447 5.10327 3.76318C5.37975 3.59176 5.69886 3.50078 6.02417 3.50049H11.9753L12.0964 3.50439ZM3.24976 12.7505C3.24984 12.9493 3.32891 13.1402 3.46948 13.2808C3.61006 13.4213 3.80096 13.5004 3.99976 13.5005H13.9998C14.1985 13.5005 14.3894 13.4212 14.53 13.2808C14.6706 13.1402 14.7497 12.9493 14.7498 12.7505V9.62549H11.8347L10.7703 11.2222C10.6543 11.3958 10.4586 11.5005 10.2498 11.5005H7.74976C7.54094 11.5004 7.34511 11.3959 7.22925 11.2222L6.16479 9.62549H3.24976V12.7505ZM6.02515 4.50049C5.88591 4.50062 5.749 4.5395 5.63062 4.61279C5.51233 4.68624 5.41628 4.79185 5.35425 4.9165L5.35327 4.91846L3.62183 8.37549H6.49976C6.70873 8.37549 6.90435 8.47993 7.02026 8.65381L8.08472 10.2505H9.91479L10.9792 8.65381C11.0951 8.48003 11.2909 8.3756 11.4998 8.37549H14.3777L12.6462 4.91846L12.6453 4.9165C12.5832 4.79171 12.4874 4.68625 12.3689 4.61279C12.2504 4.53948 12.1137 4.50056 11.9744 4.50049H6.02515Z"
        fill={color}
      />
    </svg>
  );
};

IconNewsletter.displayName = "Newsletter";

export default IconNewsletter;
